import React, { Component } from 'react';

// Assets
import redesGestionadas from '../../assets/img/contenido/redes-gestionadas.jpg';
import image from '../../assets/img/vector/redes-gestionadas.svg';
import Section from '../../layout/Section';
import SectionContainer from '../../subcomponents/SectionContainer';
import ImageText from '../../subcomponents/ImageText';
import TextImage from '../../subcomponents/TextImage';

import IconBlock from '../../subcomponents/IconBlock28';
import img1 from '../../assets/img/flat/gestionadas1.svg';
import img2 from '../../assets/img/flat/gestionadas2.svg';
import img3 from '../../assets/img/flat/gestionadas3.svg';

import cisco from '../../assets/logo/cisco.png';
import ubiquiti from '../../assets/img/brand/ubiquiti.png';
import mikrotik from '../../assets/img/brand/mikrotik.png';

class RedesGestionadas extends Component {

  componentDidMount() {
    document.title = "Redes Gestionadas - Insacom";
  }

  render() {
    const iconBlocks = [
      {
        id: 1,
        title: 'Reduzca Fallas',
        description:
          'Una red bien administrada reduce fallas y pérdidas por interrupción del servicio',
        img: img1
      },
      {
        id: 2,
        title: 'Escalable y Flexible',
        description:
          'Por diseño, nuestras soluciones están pensadas para futuro crecimiento y para adaptarse a los cambios',
        img: img2
      },
      {
        id: 3,
        title: 'Soporte',
        description: 'Siempre tendrá un experto para dar solución a eventuales problemas',
        img: img3
      }
    ];

    const descripcion =
      'Implementación, operación y Soporte de redes de datos. Nos preocupamos que tu infraestructura de red cumpla y esté alineada con los objetivos del negocio y sirva como vehículo para alcanzar los mejores resultados.';

    return (
      <Section asuntoContacto={'Redes Gestionadas'}>
        <SectionContainer grey paddingBottom={'0px'}>
          <ImageText
            imageHeight="400px"
            image={image}
            title="Redes Gestionadas"
            description={descripcion}>
            <div className="d-flex justify-content-around flex-wrap">
              <div className="align-self-center p-2">
                <img src={mikrotik} alt="Mikrotik" style={{ height: '40px' }}></img>
              </div>
              <div className="align-self-center p-2">
                <img src={ubiquiti} alt="Ubiquiti" style={{ height: '60px' }}></img>
              </div>
              <div className="align-self-center p-2">
                <img src={cisco} alt="Cisco" style={{ height: '60px' }}></img>
              </div>
            </div>
          </ImageText>
        </SectionContainer>
        <SectionContainer>
          <IconBlock version={1} content={iconBlocks}></IconBlock>
        </SectionContainer>
        <SectionContainer grey>
          <TextImage image={redesGestionadas} title="Características" description="Tener control y visibilidad de la infraestrcutura de red te permitirá tomar mejores
              decisiones a la hora de proyectar crecimiento, solucionar problemas y/o invertir en
              nuevo equipamiento.">
            <ul className="list-unstyled mb-0 mt-4">
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Levantamiento de requerimientos.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Instalación y configuración de equipamiento.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Contrato de Operación, soporte y mantenimiento.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Troubleshooting.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Asesoría constante.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Red siempre actualizada.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Monitoreo proactivo de equipamiento y enlaces.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Visibilidad e información en línea.
                </p>
              </li>
            </ul>
          </TextImage>
        </SectionContainer>
      </Section>
    );
  }
}

export default RedesGestionadas;



// WEBPACK FOOTER //
// ./src/sections/ti/RedesGestionadas.js